import axios from "axios"
import Cookies from "universal-cookie"
import { decodeText } from './encrypt'

const cookies = new Cookies()

const http = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_API_URL || 'https://api2dev.asiacommerce.net'}`,
})

const clearSession = () => {
  cookies.remove('manage-session', { path: '/' })
  cookies.remove('authData', { path: '/' })
  delete http.defaults.headers.common.Authorization
}

const handleUnauthorized = () => {
  clearSession()

  if (window.location.pathname !== '/login') {
    window.location.replace('/login')
  }
}

http.interceptors.request.use(
  (config) => {
    const sessionLogin = cookies.get('manage-session')
    if (sessionLogin) {
      const decodeSession = decodeText(sessionLogin)
      const parsedData = JSON.parse(decodeSession)
      config.headers['Authorization'] = `Bearer ${parsedData.access_token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  (res) => {
    return res
  },
  async (error) => {
    const status = error?.response?.status
    const errorMessage = error?.response?.data?.message

    if (status === 401 || errorMessage === 'Unauthorized') {
      handleUnauthorized()
    }

    return Promise.reject(error)
  }
)

export default http
